import { queryOptions } from '@tanstack/react-query'
import { getMe, isUnauthorized } from '../lib/api'
import { authClient } from '../lib/authClient'
import type { User } from '../types'

export const sessionKeys = {
	all: ['session'] as const,
	me: () => [...sessionKeys.all, 'me'] as const,
	hasPasskey: (userId: string) => [...sessionKeys.all, 'has-passkey', userId] as const,
}

async function currentUser(): Promise<User | null> {
	try {
		return await getMe()
	} catch (error) {
		if (isUnauthorized(error)) return null
		throw error
	}
}

export const sessionQuery = () =>
	queryOptions({
		queryKey: sessionKeys.me(),
		queryFn: currentUser,
		staleTime: 5 * 60 * 1000,
		retry: false,
	})

async function hasRegisteredPasskey(): Promise<boolean> {
	const { data } = await authClient.passkey.listUserPasskeys()
	return (data?.length ?? 0) > 0
}

export const hasPasskeyQuery = (userId: string) =>
	queryOptions({
		queryKey: sessionKeys.hasPasskey(userId),
		queryFn: hasRegisteredPasskey,
		enabled: userId !== '' && typeof window.PublicKeyCredential !== 'undefined',
		staleTime: Infinity,
	})
